import httpClient from '../utils/http'
import _ from 'lodash';
import { handleResponseAsync } from '../utils/HelperUtils';

export const branchService = {
  getAllBranch
};

function convertViewModelList(data) {
  let viewModel = [];
  // const defaultOption = {
  //   id: 'all',
  //   value: 'all',
  //   label: '-- All Branches --'
  // };
  // viewModel.push(defaultOption);
  if (!_.isEmpty(data) && _.isArray(data)) {
    data.map(o => {
      o.id = o._id;
      o.value = o.BranchId;
      o.label = o.BranchName;

      delete o._id;
      delete o.BranchId;
      delete o.BranchName;
      viewModel.push(o);
    });
  }
  return viewModel;
}

function getAllBranch() {
  const url = '/api/branches';

  // const config = {
  //   headers: {
  //     'content-type': 'application/json'
  //   }
  // };

  return httpClient
    .get(url)
    .then(handleResponseAsync)
    .then(res => convertViewModelList(res.data));
}
